module.exports = __webpack_public_path__ + "static/img/couponM.5a79d05e.png";